module.exports = __webpack_public_path__ + "Roboto-LightItalic.1a9e39e536aed26b863b.svg";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-LightItalic.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-LightItalic.svg
// module chunks = 34